import { useCallback, useMemo } from "react";

import {
  AvailableIntegrationFragment,
  IntegrationAbility,
  Role,
} from "@/apollo/types";
import { useIntegrationFlagHelper } from "@/integrations";
import { useUserRole } from "@/providers/account";

import { createConnectorOption } from "./createConnectorOption";
import { createEmptyIntegration } from "./helpers";
import { useAvailableIntegrations } from "./useAvailableIntegrations";

const weldSampleData = createConnectorOption(
  createEmptyIntegration("weld-sample-data", "Weld Sample Data", [
    IntegrationAbility.EltSource,
  ]),
  { elt: "show", reverseElt: "hide" },
  Role.Admin,
);

export function useConnectorOptions(params: {
  dwIntegration: AvailableIntegrationFragment;
}) {
  const integrations = useAvailableIntegrations(params.dwIntegration);
  const getIntegrationFlags = useGetIntegrationFlags();
  const userRole = useUserRole();
  const options = useMemo(() => {
    return integrations
      .map((integration) => {
        const flags = getIntegrationFlags(integration.id);
        return createConnectorOption(integration, flags, userRole);
      })
      .concat(weldSampleData);
  }, [integrations, getIntegrationFlags, userRole]);
  return options;
}

function useGetIntegrationFlags() {
  const integrationFlagHelper = useIntegrationFlagHelper();
  return useCallback(
    (integrationId: string) => {
      return {
        elt: integrationFlagHelper.checkFlag(
          integrationId,
          IntegrationAbility.EltSource,
        ),
        reverseElt: integrationFlagHelper.checkFlag(
          integrationId,
          IntegrationAbility.ActivateDestination,
        ),
      };
    },
    [integrationFlagHelper],
  );
}
